module.exports = __webpack_public_path__ + "static/media/mohren-loader-gruen.82f532d5.gif";